<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const { open } = useSearchModal()
</script>
<template>
  <HeaderActionButton class="hover" :aria-label="t('search.form.button')" @click="open">
    <Icon name="search" />
  </HeaderActionButton>
  <ModalSearch />
</template>
